"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeContractsClient = void 0;
const Projection_1 = require("../../common/model/Projection");
const ContractsConverter_1 = require("../ContractsConverter");
class FakeContractsClient {
    constructor() {
        this.contracts = [];
    }
    getAll(page, projection) {
        return Promise.resolve({
            page: projection === Projection_1.Projection.LIST
                ? this.contracts.map((full) => ({
                    id: full.id,
                    contentPartnerName: full.contentPartnerName,
                }))
                : this.contracts,
            pageSpec: {
                number: page.page,
                size: page.size,
                totalElements: this.contracts.length,
                totalPages: Math.ceil(this.contracts.length / page.size),
            },
        });
    }
    clear() {
        this.contracts = [];
    }
    create(request) {
        const contractId = { value: 'contract-id' };
        this.insertFixture({
            ...request,
            restrictions: {
                ...request.restrictions,
                aiRestrictions: {
                    internalUse: ContractsConverter_1.ContractsConverter.convertToAiPermissionsType(request.restrictions?.aiRestrictions?.internalUse),
                    llmUse: ContractsConverter_1.ContractsConverter.convertToAiPermissionsType(request.restrictions?.aiRestrictions?.llmUse),
                    info: request.restrictions?.aiRestrictions?.info,
                },
                territoryRestrictions: {
                    restrictionsType: ContractsConverter_1.ContractsConverter.convertTerritoryRestrictionsType(request.restrictions?.territoryRestrictions?.restrictionsType),
                    territories: request.restrictions?.territoryRestrictions?.territories?.map((territory) => ({
                        code: territory.code,
                        label: territory.code,
                    })),
                },
            },
            costs: {
                ...request.costs,
                minimumGuarantee: request.costs?.minimumGuarantee
                    ? request.costs.minimumGuarantee
                    : [],
            },
            id: contractId,
        });
        return Promise.resolve(contractId);
    }
    update(id, contractUpdate) {
        const index = this.contracts.findIndex((i) => i.id.value === id);
        if (index < 0) {
            return Promise.reject();
        }
        const updatedFields = {};
        Object.assign(updatedFields, contractUpdate);
        this.contracts[index] = {
            ...this.contracts[index],
            ...updatedFields,
        };
        return Promise.resolve();
    }
    get() {
        if (this.contracts[0]) {
            return Promise.resolve(this.contracts[0]);
        }
        else {
            throw new Error('No content partner contracts have been set on the FakeContractsClient');
        }
    }
    insertFixture(contract) {
        this.contracts.push(contract);
    }
    getSignedLink(filename) {
        const newFilename = filename.replace('.', '_') + '_signed_link';
        const signedLinkUrl = `http://www.server.com/${newFilename}`;
        return new Promise((resolve) => resolve(signedLinkUrl));
    }
}
exports.FakeContractsClient = FakeContractsClient;
//# sourceMappingURL=FakeContractsClient.js.map